<script setup lang="ts">
import { VideoProps } from "./Video.props"
const props = withDefaults(defineProps<VideoProps>(), {
  hasAutoplay: true,
  isPortraitInMobile: false,
  onPlayerReady: () => null,
  pauseChanged: () => null
})
const noVideoSuggestionParameter = "rel=0"
const autoplayParameter = "&autoplay=1&mute=1"
const hasAutoplayParams = `${props.hasAutoplay ? autoplayParameter : ""}`
const youtubeIdWithParams = props.youtubeId
  ? `${props.youtubeId}?${noVideoSuggestionParameter}${hasAutoplayParams}`
  : undefined

const isPortraitOnMobile = () => {
  if (props.isPortraitInMobile && sm.value) {
    return "auto"
  }
  return "16:9"
}
</script>

<template>
  <ClientOnly>
    <AppVideo
      :class="appVideoClasses"
      :videoSrc="sm && mobileVideoSrc ? mobileVideoSrc : videoSrc"
      :youtubeId="youtubeIdWithParams"
      :vimeoId="vimeoId ?? undefined"
      :clickToPlay="sm ? true : false"
      :clickToPlaySettings="{ useOnMobile: true }"
      :playerSettings="{
        autoplay: hasAutoplay,
        muted: hasAutoplay ? true : false,
        controls: true,
        aspectRatio: isPortraitOnMobile()
      }"
      :videoSettings="{
        autoplay: hasAutoplay,
        muted: hasAutoplay ? true : false,
        controls: true,
        aspectRatio: isPortraitOnMobile()
      }"
      :youtubeSettings="{
        autoplay: hasAutoplay,
        muted: hasAutoplay ? true : false,
        controls: true,
        aspectRatio: isPortraitOnMobile()
      }"
      :vimeoSettings="{
        autoplay: hasAutoplay,
        muted: hasAutoplay ? true : false,
        controls: true,
        aspectRatio: isPortraitOnMobile()
      }"
      @ready="onPlayerReady"
      @pauseChanged="pauseChanged"
    />
  </ClientOnly>
</template>
